import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicalCrossSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMedicalCrossSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13.5 10.5V7.5H10.5V10.5H7.5V13.5H10.5V16.5H13.5V13.5H16.5V10.5H13.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconMedicalCrossSquare;
